import { Component, Inject, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute} from '@angular/router';
import { ResetPasswordRequest } from '@dto/resetPasswordRequest';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { PasswordConfirmationValidatorService } from '@services/custom-validators/password-confirm-validator.service';
import { MessageService } from '@services/message/message.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  public resetPasswordForm: UntypedFormGroup;
  
  private token: string;
  private email: string;

  @ViewChild('successMessage') successMessage: TemplateRef<any>;

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private authenticationService: AuthenticationService,
    private passwordConfirmValidator: PasswordConfirmationValidatorService,
    private route: ActivatedRoute,
    public messageService: MessageService,
    injector: Injector) { }

  ngOnInit(): void {
    this.resetPasswordForm = new UntypedFormGroup({
      password: new UntypedFormControl('', [Validators.required]),
      confirm: new UntypedFormControl('')
    });

    this.resetPasswordForm.get('confirm').setValidators([Validators.required,
      this.passwordConfirmValidator.validateConfirmPassword(this.resetPasswordForm.get('password'))]);

    this.token = this.route.snapshot.queryParams['token'];
    this.email = this.route.snapshot.queryParams['email'];
  }

  validateControl(controlName: string) {
    return this.resetPasswordForm.controls[controlName].invalid && this.resetPasswordForm.controls[controlName].touched
  }

  hasError (controlName: string, errorName: string) {
    return this.resetPasswordForm.controls[controlName].hasError(errorName)
  }

  resetPassword(resetPasswordFormValue) {
    const resetPass = { ...resetPasswordFormValue };

    const resetPasswordRequest: ResetPasswordRequest = {
      password: resetPass.password,
      confirmPassword: resetPass.confirm,
      token: this.token,
      email: this.email
    }

    this.authenticationService.resetPassword(resetPasswordRequest).subscribe(result => {
      this.messageService.setSuccess(this.successMessage);
    }, error => {
      this.messageService.setError(error);
    })
  }

}
